import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

import * as authSelectors from '../../../Core/Auth/auth.selectors'
import * as selectors from '../battles.selectors'
import * as actions from '../battles.actions'

import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'
import AnswerBattle from './AnswerBattle'

const mapDispatchToProps = (dispatch) => ({
  giveUp: bindActionCreators(actions.giveUp, dispatch),
  answerBattleQuestion: bindActionCreators(actions.answerBattleQuestion, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
})
const mapStateToProps = (state) => ({
  currentQuestion: selectors.getCurrentBattleQuestion(state),
  info: selectors.getBattleInfoFromState(state),
  battle: selectors.getCurrentBattle(state),
  userInfo: authSelectors.getUserInfo(state),
  loading: selectors.getBattleLoading(state),
  individualBattle: selectors.getIndividualBattle(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AnswerBattle))
